<template>
  <div>
    <warehouseIntoAdd nature='1' ref="warehouseIntoAdd" :warehouseCode='warehouseCode'>
      <template slot="productionDate" slot-scope="row">
        <el-button type="text" @click="editDate(row)" :disabled="$has('assignmentManageAdd')">选择生产日期</el-button>
      </template>
    </warehouseIntoAdd>
    <el-button class="submit-btn" type="primary" @click="submit">保存</el-button>

    <!-- 生产日期 - 弹窗 -->
    <el-dialog :title="formDialog.title" :visible.sync="formDialog.visibel" :show-close="false">
      <el-table
        :data="formInfo"
        border
        style="width: 100%">
        <el-table-column
          min-width="160px"
          prop="ytgbProductionTime"
          label="生产日期">
          <template slot-scope="scope">
            <div class="flexCenter">
              <el-select v-model="scope.row.ytgbProductionTime" placeholder="请选择">
                <el-option
                  v-for="(item,index) in goodsBatchDisabledSelect[scope.$index]"
                  :key="index"
                  :label="item.productionTime"
                  :value="item.productionTime"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
              <i class="el-icon-circle-plus-outline" v-if="scope.$index == 0" @click="handelAdd"></i>
              <i class="el-icon-remove-outline" v-else @click="handelDel(scope.$index)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="ysdgValidityTime"
          label="有效期至">
          <template slot-scope="scope">
            <span :style="isOverdueList[scope.$index] ? 'color:red' : ''">{{ getExpDays[scope.$index].ysdgValidityTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="inventory"
          label="可用库存">
          <template slot-scope="scope">
            <p>{{ getExpDays[scope.$index].inventory }}{{ scope.row.minUnitName }}</p>
            <p style="color: #aaa">(
            {{ parseInt(getExpDays[scope.$index].inventory / currentInfo.box) }}{{ currentInfo.maxUnitName }}
            {{ parseInt(getExpDays[scope.$index].inventory % currentInfo.box) }}{{ currentInfo.minUnitName }}
            )</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="unavailable"
          label="不可用库存">
          <template slot-scope="scope">
            <p>{{ getExpDays[scope.$index].unavailable }}{{ scope.row.minUnitName }}</p>
            <p style="color: #aaa">(
            {{ parseInt(getExpDays[scope.$index].unavailable / currentInfo.box) }}{{ currentInfo.maxUnitName }}
            {{ parseInt(getExpDays[scope.$index].unavailable % currentInfo.box) }}{{ currentInfo.minUnitName }}
            )</p>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="ytgbNormal"
          label="计划数量（正常品）">
          <template slot-scope="scope">
            <el-input v-model="scope.row.ytgbNormal" placeholder="请输入" @blur="checkNumber('ytgbNormal',scope.$index,scope.row.ytgbNormal)">
              <template slot="append">{{ scope.row.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isExit"
          min-width="120px"
          prop="ytgbBroken"
          label="计划数量（破损品）">
          <template slot-scope="scope">
            <el-input v-model="scope.row.ytgbBroken" placeholder="请输入" @blur="checkNumber('ytgbBroken',scope.$index,scope.row.ytgbBroken)">
              <template slot="append">{{ scope.row.minUnitName }}</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <p style="text-align: right;margin-top: 20px;font-size: 16px;">合计：正常品{{ total[0] }}件，破损品{{ total[1] }}件</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import warehouseIntoAdd from '@/page/assignmentManage/warehouse/warehouseIntoAdd'
import assignmentManage from '@/store/assignmentManage/index'
import { GETGOODSBATCH } from '@/store/assignmentManage/types'

export default {
  name: 'warehouseoutadd',
  components: {
    warehouseIntoAdd
  },
  data () {
    return {
      warehouseCode: '',
      currentInfo: {},
      formInfo: [
        {
          ytgbProductionTime: '',
          ytgbNormal: 0,
          ytgbBroken: 0,
          index: 1
        }
      ],
      formDialog: {
        title: '选择生产日期',
        visibel: false
      },
      isOverdueGoodsList: {}, // 过期商品列表
      pageLoad: false
    }
  },
  mounted () {
    this.pageLoad = true
    this.warehouseCode = this.$route.params.warehouseCode
  },
  methods: {
    // 获取生产日期 - 下拉框
    getGoodsBatchSelect (goodsCode) {
      let params = {
        goodsCode
      }
      this.$store.dispatch(GETGOODSBATCH, params)
    },
    // 编辑
    editDate ({index}) {
      this.getGoodsBatchSelect(this.goodsList[index].goodsCode)
      this.formDialog.visibel = true
      this.currentInfo = this.goodsList[index]

      // 回显生产日期
      this.formInfo = this.goodsList[index].batchList ? JSON.parse(JSON.stringify(this.goodsList[index].batchList)) : [{
        ytgbProductionTime: '',
        ytgbNormal: 0,
        ytgbBroken: 0,
        index: 1
      }]
    },
    // 日期新增
    handelAdd () {
      let result = this.formInfo.find(item => item.ytgbProductionTime === '' || item.ytgbNormal === '' || item.ytgbBroken === '')
      if (result !== undefined) return this.$message.error(`请填写完整数据`)
      this.formInfo.push({
        ytgbProductionTime: '',
        ytgbNormal: 0,
        ytgbBroken: 0,
        index: this.formInfo.length + 1
      })
    },
    // 日期删除
    handelDel (index) {
      this.formInfo.splice(index, 1)
    },
    // 确定
    sure () {
      if (!this.checkValidate()) return false
      this.goodsList.forEach(item => {
        if (this.currentInfo.goodsCode === item.goodsCode) {
          item.batchList = this.formInfo
          item.num1 = this.total[0]
          item.wornNum = this.total[1]
          // 是否有过期商品 - 保存时需要提示
          if (this.isOverdueList.indexOf(true) > -1) {
            this.isOverdueGoodsList[item.goodsCode] = item.name
          } else {
            delete this.isOverdueGoodsList[item.goodsCode]
          }
        }
      })
      this.handleClose()
    },
    // 保存
    submit () {
      let isOverdueGoodsList = []
      let overdueNameList = []
      for (let key in this.isOverdueGoodsList) {
        isOverdueGoodsList.push(key)
      }
      this.goodsList.forEach(item => {
        if (isOverdueGoodsList.indexOf(item.goodsCode) > -1) {
          overdueNameList.push(`"${item.name}"`)
        }
      })
      if (this.goodsList.length === 0 || overdueNameList.length === 0) return this.$refs.warehouseIntoAdd.submitConfig()
      overdueNameList = overdueNameList.join('、')
      this.$confirm(`商品${overdueNameList}中包含过期商品，您确定要保存吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.warehouseIntoAdd.submitConfig()
      })
    },
    // 保存校验
    checkValidate () {
      let flag = true
      let isNull = this.formInfo.find(item => item.ytgbProductionTime === '' || item.ytgbNormal === '' || item.ytgbBroken === '')
      if (isNull !== undefined) {
        flag = false
        this.$message.error(`请填写完整数据`)
      }
      if (flag) {
        let isThan = this.formInfo.find((item, index) => (parseInt(item.ytgbNormal) > this.getExpDays[index].inventory) || (parseInt(item.ytgbBroken) > this.getExpDays[index].unavailable))
        if (isThan !== undefined) {
          flag = false; this.$message.error(`第${isThan.index}条输入有误`)
        }
      }
      return flag
    },
    // 校验数字
    checkNumber (key, i, number) {
      if (number) this.formInfo[i][key] = number.replace(/[^\d]/g, '')
    },
    // 关闭弹窗
    handleClose () {
      this.formDialog.visibel = false
      this.formInfo = []
      this.currentInfo = {}
    },
    // 获取今天日期 - 年月日
    getCurrentDate () {
      var nowDate = new Date()
      var year = nowDate.getFullYear()
      var month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1)
        : nowDate.getMonth() + 1
      var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate
        .getDate()
      return year + '-' + month + '-' + day
    },
    // 获取N天后的日期
    getDateStr (today, addDayCount) {
      var dd
      if (today) {
        dd = new Date(today)
      } else {
        dd = new Date()
      }
      dd.setDate(dd.getDate() + addDayCount)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    }
  },
  computed: {
    // 选中的商品列表
    goodsList () {
      if (this.$refs.warehouseIntoAdd) {
        return this.$refs.warehouseIntoAdd.goodsList.rows
      }
      return []
    },
    // 生产日期合计（正常品、破损品）
    total () {
      let list = [0, 0]
      this.formInfo.forEach(item => {
        list[0] += parseInt(item.ytgbNormal) || 0
        list[1] += parseInt(item.ytgbBroken) || 0
      })
      return list
    },
    // 生产日期 - 下拉框
    goodsBatchSelect () {
      return assignmentManage.state.goodsBatchSelect
    },
    // 生产日期 - 下拉框(禁止项)
    goodsBatchDisabledSelect () {
      let list = []
      let ids = this.formInfo.map(item => item.ytgbProductionTime)
      this.formInfo.forEach(item => {
        let arr = []
        this.goodsBatchSelect.forEach(v => {
          if (ids.indexOf(v.productionTime) > -1) {
            return arr.push({...v, disabled: true})
          }
          arr.push(v)
        })
        list.push(arr)
      })
      return list
    },
    // 获取有限期至
    getExpDays () {
      let list = []
      this.formInfo.forEach((item, index) => {
        if (item.ytgbProductionTime) {
          let result = this.goodsBatchSelect.find(v => v.productionTime === item.ytgbProductionTime)
          list.push({
            ysdgValidityTime: this.currentInfo.expDays === 0 || item.ytgbProductionTime === '无' ? '-' : this.getDateStr(item.ytgbProductionTime, this.currentInfo.expDays),
            inventory: result.normal, // 可用库存
            unavailable: result.broken // 不可用库存
          })
        } else {
          list.push({
            ysdgValidityTime: '',
            inventory: 0, // 可用库存
            unavailable: 0 // 不可用库存
          })
        }
      })
      return list
    },
    // 有效期是否过期 - 颜色标红
    isOverdueList () {
      let arr = []
      this.formInfo.forEach((item, index) => {
        // 正常的日期 - 年月日
        if (this.getExpDays[index].ysdgValidityTime) {
          let itemDate = new Date(this.getExpDays[index].ysdgValidityTime).getTime()
          let result = new Date(this.getCurrentDate()).getTime() > itemDate // 判断有效期 是否小于当前日期
          return arr.push(result)
        }
        arr.push(false)
      })
      return arr
    },
    // 是否为退场任务 或者 其他出库
    isExit () {
      if (this.pageLoad) {
        return this.$refs.warehouseIntoAdd.formInfo.data.type === 'TASK_TYPE_EMPTY' || this.$refs.warehouseIntoAdd.formInfo.data.type === 'TASK_TYPE_OTHER_OUT'
      }
    }
  }
}
</script>

<style scoped>
  .el-button--text {
    font-size: 14px !important;
  }
  .flexCenter {
    display: flex;
    align-items: center;
    justify-self: center;
  }
  .el-icon-remove-outline,
  .el-icon-circle-plus-outline {
    font-size: 24px;
    color: #409EFF;
    margin-left: 6px;
  }
  .submit-btn {
    position: fixed;
    right: 120px;
    bottom: 20px;
    z-index: 111
  }
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/warehouseOutAdd.vue